import './iframe.less'

import React from 'react'
import {WysiwygType} from 'types'
import {style} from 'util/style'
import {Trusted} from 'util/trusted'
import {Title} from 'views/layout/title'
import {Theme} from 'views/theme'

const styles = style('iframe')

export type IframeType = {
	title?: string
	subtitle?: string
	text?: WysiwygType
	iframe: string
	iframe_enable_ratio?: boolean
}

export const Iframe: React.FC<IframeType> = ({
	title,
	subtitle,
	text,
	iframe,
	iframe_enable_ratio
}) => {
	if (!iframe) return null
	const aspectratio =
		iframe_enable_ratio && !!iframe.match(/maps|vimeo|youtube/)
	const strippedIframe = iframe.replace(/(<p[^>]+?>|<p>|<\/p>)/gim, '')

	return (
		<div className={styles()}>
			<Theme.OuterContainer>
				<Theme.Container>
					<div className={styles('content')}>
						<Title
							className={styles('content-title')}
							title={title}
							subtitle={subtitle}
						/>
						{text && (
							<div className={styles('content-text')}>
								<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
							</div>
						)}
					</div>
					<div
						className={styles('iframecontainer').mod({
							aspectratio
						})}
					>
						<Trusted>{strippedIframe}</Trusted>
					</div>
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}
